import { PreloadingStrategy, Route } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';

export class CustomPreloadingStrategy implements PreloadingStrategy {
	preload(route: Route, load: () => Observable<any>): Observable<any> {
		return this.shouldPreload(route) ? load() : EMPTY;
	}

	shouldPreload(route: any): boolean {
		if ((navigator as any)?.connection?.saveData === true) {
			return false;
		}
		return route?.data?.preload !== false;
	}
}

// Copyright (c) Motorola Solutions Inc. All Rights Reserved.
